import { useState, useCallback, useEffect, useMemo } from 'react';
import { useIntl } from 'gatsby-plugin-react-intl';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import MultiColumnLayout from '../MultiColumnLayout';

import BlogMobileCarousel from './BlogMobileCarousel';

let mediaQuery;

export const BlogCards = ({ data = null, className = '' }) => {
  const intl = useIntl();

  const defaultBlogPosts = useStaticQuery(query);
  const blogPosts = useMemo(
    () =>
      intl.locale === 'en'
        ? defaultBlogPosts.en.nodes
        : defaultBlogPosts.fr.nodes,
    [intl.locale],
  );

  const cardData = data?.blogPosts ? data : { ...data, blogPosts };

  const [mobile, setMobile] = useState(false);

  const matchMedia = useCallback((breakpoint = mediaQuery) => {
    if (breakpoint.matches) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      mediaQuery = window.matchMedia('(max-width: 1023px)');
      mediaQuery.addListener(matchMedia);
      matchMedia();
    }
    return () => {
      mediaQuery.removeListener(matchMedia);
    };
  }, []);

  return mobile ? (
    <BlogMobileCarousel data={cardData} containerClass={className} />
  ) : (
    <MultiColumnLayout
      data={cardData}
      componentType="blog-card-updated"
      containerClass={className}
    />
  );
};

BlogCards.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]),
  className: PropTypes.string,
};

// Query three most recent posts to use as defaults if no
// blog posts are selected in the CMS
const query = graphql`
  query BlogSectionStaticQuery {
    en: allContentfulArticles(
      sort: { publishDate: DESC }
      filter: {
        node_locale: { eq: "en-CA" }
        publishDate: { ne: null }
        contentful_id: { nin: "NzWC96F3UrWflGeHGnYlC" }
        articleType: { eq: "blog" }
      }
      limit: 3
    ) {
      nodes {
        ...blog_post_fragment
      }
    }
    fr: allContentfulArticles(
      sort: { publishDate: DESC }
      filter: {
        node_locale: { eq: "fr-CA" }
        publishDate: { ne: null }
        contentful_id: { nin: "NzWC96F3UrWflGeHGnYlC" }
        articleType: { eq: "blog" }
        showFrench: { eq: true }
      }
      limit: 3
    ) {
      nodes {
        ...blog_post_fragment
      }
    }
  }
`;
